<div [formGroup]="parcelamentoGroup">
  @if (isMultiParcela) {
    <!-- ─── Edição: múltiplas parcelas → grid somente leitura ─── -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="section-subtitle mb-0">
        <mat-icon>table_chart</mat-icon>
        <span>Parcelas do Documento</span>
      </div>
      @if (hasParcelasEmAberto) {
        <span [matTooltip]="motivoRenegociarBloqueado" [matTooltipDisabled]="!motivoRenegociarBloqueado">
          <button type="button" mat-stroked-button class="btn-secondary" [disabled]="!!motivoRenegociarBloqueado" (click)="renegociarClick.emit()">
            <mat-icon>autorenew</mat-icon> Renegociar
          </button>
        </span>
      }
    </div>
    <div formArrayName="parcelas">
      <!-- Parcelas ativas (não canceladas) -->
      @for (item of parcelasAtivas; track item.index) {
        <div class="row" [formGroupName]="item.index">
          <div class="col-1 simulacao-index">{{ item.ctrl.get('nroParcela')?.value }}</div>
          <div class="col-12 col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vencimento</mat-label>
              <input matInput readonly [value]="item.ctrl.get('dataVencimento')?.value | date: 'dd/MM/yyyy'" />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor (R$)</mat-label>
              <input matInput formControlName="valor" [currencyMask]="currencyMask" readonly />
            </mat-form-field>
          </div>
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descrição</mat-label>
              <input matInput formControlName="descricao" readonly />
            </mat-form-field>
          </div>
          <div class="col-2 col-md-1">
            <button
              mat-icon-button
              type="button"
              [routerLink]="['/financas/contas-receber/parcela', item.ctrl.get('idContasReceberParcela')?.value]"
              [queryParams]="idContasReceber ? { idContasReceber: idContasReceber } : {}"
              matTooltip="Editar parcela">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
      }

      <!-- Parcelas canceladas: bloco recolhível (não some, só separa) -->
      @if (parcelasCanceladas.length > 0) {
        <div class="canceladas-header" (click)="mostrarCanceladas = !mostrarCanceladas">
          <mat-icon>{{ mostrarCanceladas ? 'expand_more' : 'chevron_right' }}</mat-icon>
          <span>Parcelas canceladas ({{ parcelasCanceladas.length }})</span>
        </div>

        @if (mostrarCanceladas) {
          @for (item of parcelasCanceladas; track item.index) {
            <div class="row parcela-cancelada" [formGroupName]="item.index">
              <div class="col-1 simulacao-index">{{ item.ctrl.get('nroParcela')?.value }}</div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Vencimento</mat-label>
                  <input matInput readonly [value]="item.ctrl.get('dataVencimento')?.value | date: 'dd/MM/yyyy'" />
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Valor (R$)</mat-label>
                  <input matInput formControlName="valor" [currencyMask]="currencyMask" readonly />
                </mat-form-field>
              </div>
              <div class="col-12 col-md-5">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Descrição</mat-label>
                  <input matInput formControlName="descricao" readonly />
                </mat-form-field>
              </div>
              <div class="col-2 col-md-1 d-flex align-items-center">
                <span class="badge-cancelada">Cancelada</span>
              </div>
            </div>
          }
        }
      }
    </div>
  } @else if (isEditMode) {
    <!-- ─── Edição: parcela única (à vista ou recorrente) ─── -->
    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Vencimento</mat-label>
          <input
            matInput
            [matDatepicker]="pickerEditVenc"
            formControlName="dataVencimento"
            (input)="onDateInput($event, 'dataVencimento')" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerEditVenc"></mat-datepicker-toggle>
          <mat-datepicker #pickerEditVenc></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-12 col-md-4">
        @if (listaFormaRecebimento.length > 0) {
          <app-select-pesquisavel
            [control]="idFormaRecebimentoControl"
            [offlineList]="listaFormaRecebimentoFiltrada"
            label="Forma de Recebimento"
            idField="idFormaRecebimento"
            nameField="descricao"
            [isOptional]="!isObrigatorio('id_forma_recebimento')">
          </app-select-pesquisavel>
        }
      </div>

      <div class="col-12 col-md-4">
        @if (listaContaFinanceira.length > 0) {
          <app-select-pesquisavel
            [control]="idContaFinanceiraControl"
            [offlineList]="listaContaFinanceiraFiltrada"
            label="Conta de recebimento"
            idField="idContaFinanceira"
            nameField="descricao"
            [isOptional]="!isObrigatorio('id_conta_financeira')">
          </app-select-pesquisavel>
        }
      </div>

      <div class="col-12 col-md-4 d-flex align-items-center mb-4">
        <mat-slide-toggle color="primary" formControlName="isRecebido"> Recebido </mat-slide-toggle>
      </div>
    </div>
  } @else {
    <!-- ─── Criação: toggle + 3 estados ─── -->
    <div class="row align-items-center mb-3">
      <div class="col-12 col-md-4">
        <mat-slide-toggle color="primary" formControlName="isRecorrente"> Recorrente </mat-slide-toggle>
      </div>
    </div>

    @if (isRecorrente) {
      <div class="row">
        <div class="col-12 mb-2">
          <mat-icon class="material-symbols-outlined">repeat</mat-icon> Configuração de Recorrência
        </div>

        <div class="col-6 col-md-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Repetir a cada</mat-label>
            <input matInput [currencyMask]="integerMask" formControlName="recorrenciaIntervalo" placeholder="Ex: 1" />
          </mat-form-field>
        </div>

        <div class="col-6 col-md-3">
          @if (listaFrequencia.length > 0) {
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Período</mat-label>
              <mat-select formControlName="idFrequenciaRecorrencia">
                @for (item of listaFrequencia; track item) {
                  <mat-option [value]="item.idFrequenciaRecorrencia">{{ item.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>

        <div class="col-6 col-md-3">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Qtd. de Vezes</mat-label>
            <input matInput [currencyMask]="integerMask" formControlName="recorrenciaQuantidade" placeholder="Ocorrências" />
          </mat-form-field>
        </div>

        <div class="col-6 col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Vencimento do 1º Lançamento</mat-label>
            <input
              matInput
              [matDatepicker]="pickerPri"
              formControlName="dataVencimento"
              (input)="onDateInput($event, 'dataVencimento')" />
            <mat-datepicker-toggle matIconSuffix [for]="pickerPri"></mat-datepicker-toggle>
            <mat-datepicker #pickerPri></mat-datepicker>
          </mat-form-field>
        </div>

        @if (mostrarDiaVencimentoFixo) {
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Dia de Vencimento Fixo</mat-label>
            <input
              matInput
              [currencyMask]="diaVencimentoMask"
              formControlName="recorrenciaDiaVencimento"
              placeholder="Dia no Mês (opcional)" />
          </mat-form-field>
        </div>
        }

        <div class="col-12 col-md-4">
          @if (listaFormaRecebimento.length > 0) {
            <app-select-pesquisavel
              [control]="idFormaRecebimentoControl"
              [offlineList]="listaFormaRecebimentoFiltrada"
              label="Meio de Recebimento (Forma)"
              idField="idFormaRecebimento"
              nameField="descricao"
              [isOptional]="!isObrigatorio('id_forma_recebimento')">
            </app-select-pesquisavel>
          }
        </div>
        <div class="col-12 col-md-4">
          @if (listaContaFinanceira.length > 0) {
            <app-select-pesquisavel
              [control]="idContaFinanceiraControl"
              [offlineList]="listaContaFinanceiraFiltrada"
              label="Conta de recebimento padrão"
              idField="idContaFinanceira"
              nameField="descricao"
              [isOptional]="!isObrigatorio('id_conta_financeira')">
            </app-select-pesquisavel>
          }
        </div>

        <div class="col-12 simular-btn-container">
          <button
            type="button"
            mat-stroked-button
            class="btn-secondary"
            (click)="simular()"
            [disabled]="!podeSimular || isSimulando">
            @if (isSimulando) {
              <mat-spinner diameter="18" class="me-2"></mat-spinner>
            } @else {
              <span> <mat-icon>preview</mat-icon> Simular Recorrência </span>
            }
          </button>
        </div>
      </div>
    } @else {
      <div class="row">
        <!-- Selector de tipo: sempre visível -->
        <div class="col-12 col-md-4">
          @if (listaTiposParcelamento.length > 0) {
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Condição / Tipo</mat-label>
              <mat-select formControlName="idTipoParcelamento">
                @for (item of listaTiposParcelamento; track item) {
                  <mat-option [value]="item.idTipoParcelamento">{{ item.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>

        @if (!isParcelado) {
          <!-- ─── À vista ─── -->
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vencimento</mat-label>
              <input
                matInput
                [matDatepicker]="pickerVencAvista"
                formControlName="dataVencimento"
                (input)="onDateInput($event, 'dataVencimento')" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerVencAvista"></mat-datepicker-toggle>
              <mat-datepicker #pickerVencAvista></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            @if (listaFormaRecebimento.length > 0) {
              <app-select-pesquisavel
                [control]="idFormaRecebimentoControl"
                [offlineList]="listaFormaRecebimentoFiltrada"
                label="Forma de Recebimento"
                idField="idFormaRecebimento"
                nameField="descricao"
                [isOptional]="!isObrigatorio('id_forma_recebimento')">
              </app-select-pesquisavel>
            }
          </div>

          <div class="col-12 col-md-4">
            @if (listaContaFinanceira.length > 0) {
              <app-select-pesquisavel
                [control]="idContaFinanceiraControl"
                [offlineList]="listaContaFinanceiraFiltrada"
                label="Conta de recebimento"
                idField="idContaFinanceira"
                nameField="descricao"
                [isOptional]="!isObrigatorio('id_conta_financeira')">
              </app-select-pesquisavel>
            }
          </div>

          <div class="col-12 col-md-4 d-flex align-items-center mb-4">
            <mat-slide-toggle color="primary" formControlName="isRecebido"> Recebido </mat-slide-toggle>
          </div>
        } @else {
          <!-- ─── Parcelado ─── -->
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vencimento Inicial</mat-label>
              <input
                matInput
                [matDatepicker]="pickerVencimento"
                formControlName="dataVencimento"
                (input)="onDateInput($event, 'dataVencimento')" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerVencimento"></mat-datepicker-toggle>
              <mat-datepicker #pickerVencimento></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Intervalo de Dias entre Parcelas</mat-label>
              <input matInput [currencyMask]="integerMask" formControlName="intervaloDiasParcelas" placeholder="Ex: 30" />
            </mat-form-field>
          </div>

          <div class="col-12 col-md-5">
            @if (listaFormaRecebimento.length > 0) {
              <app-select-pesquisavel
                [control]="idFormaRecebimentoControl"
                [offlineList]="listaFormaRecebimentoFiltrada"
                label="Meio de Recebimento (Forma)"
                idField="idFormaRecebimento"
                nameField="descricao"
                [isOptional]="!isObrigatorio('id_forma_recebimento')">
              </app-select-pesquisavel>
            }
          </div>

          <div class="col-12 col-md-5">
            @if (listaContaFinanceira.length > 0) {
              <app-select-pesquisavel
                [control]="idContaFinanceiraControl"
                [offlineList]="listaContaFinanceiraFiltrada"
                label="Conta de recebimento padrão"
                idField="idContaFinanceira"
                nameField="descricao"
                [isOptional]="!isObrigatorio('id_conta_financeira')">
              </app-select-pesquisavel>
            }
          </div>

          <div class="col-12 simular-btn-container">
            <button
              type="button"
              mat-stroked-button
              class="btn-secondary"
              (click)="simular()"
              [disabled]="!podeSimular || isSimulando">
              @if (isSimulando) {
                <mat-spinner diameter="18" class="me-2"></mat-spinner>
              } @else {
                <span> <mat-icon>preview</mat-icon> Simular Parcelas </span>
              }
            </button>
          </div>
        }
      </div>
    }

    <!-- Grid de Simulação (criação) -->
    @if (parcelasArray.length > 0) {
      <div class="simulacao-container mt-3">
        <div class="section-subtitle">
          <mat-icon>table_chart</mat-icon>
          <span>{{ isRecorrente ? 'Recorrências Previstas' : 'Parcelas Simuladas' }}</span>
        </div>

        @if (isRecorrente) {
          <!-- Grid Recorrência -->
          <div>
            @for (ctrl of parcelasArray.controls; track $index; let i = $index) {
              <div class="recorrencia-row">
                <div class="recorrencia-index">{{ i + 1 }}</div>
                <div class="recorrencia-fields">
                  <div class="recorrencia-field">
                    <span class="recorrencia-field-label">Criação</span>
                    <span class="recorrencia-field-value">{{ ctrl.get('dataCriacao')?.value | date: 'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="recorrencia-field">
                    <span class="recorrencia-field-label">Vencimento</span>
                    <span class="recorrencia-field-value">{{ ctrl.get('dataVencimento')?.value | date: 'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="recorrencia-field recorrencia-field-desc">
                    <span class="recorrencia-field-label">Descrição</span>
                    <span class="recorrencia-field-value">{{ ctrl.get('descricao')?.value }}</span>
                  </div>
                  <div class="recorrencia-field">
                    <span class="recorrencia-field-label">Valor (R$)</span>
                    <span class="recorrencia-field-value">{{ ctrl.get('valor')?.value | abnt: 'preco': 2 }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <!-- Grid Parcelas simuladas (editável) -->
          <div formArrayName="parcelas">
            @for (ctrl of parcelasArray.controls; track $index; let i = $index) {
              <div class="row g-2 mb-1" [formGroupName]="$index">
                <div class="col-1 simulacao-index">{{ i + 1 }}</div>
                <div class="col-12 col-md-2">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Vencimento</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerParcVenc"
                      formControlName="dataVencimento"
                      (input)="onDateInput($event, 'dataVencimento', i)" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerParcVenc"></mat-datepicker-toggle>
                    <mat-datepicker #pickerParcVenc></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-2">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Valor (R$)</mat-label>
                    <input
                      matInput
                      formControlName="valor"
                      [currencyMask]="currencyMask"
                      (blur)="onParcelaValorChange(i)" />
                  </mat-form-field>
                </div>
                <div class="col-12 col-md">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Descrição</mat-label>
                    <input matInput formControlName="descricao" />
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
          <div class="soma-parcelas-info" [class.soma-parcelas-erro]="!somaParcelasValida">
            <span>Soma das parcelas: {{ somaParcelas | abnt: 'preco': 2 }}</span>
            @if (!somaParcelasValida) {
              <span class="soma-parcelas-msg">
                <mat-icon>error_outline</mat-icon>
                A soma das parcelas precisa ser igual ao Valor Total do documento.
              </span>
            }
          </div>
        }
      </div>
    }

    @if (isRecorrente) {
      <!-- Dados comuns Recorrência -->
    }
  }
  <!-- fim @else criação -->
</div>
